"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtokolConnection = void 0;
const client_1 = require("@arkecosystem/client");
const guardian_1 = require("./resources/guardian");
const base_1 = require("./resources/nft/base");
const exchange_1 = require("./resources/nft/exchange");
class ProtokolConnection extends client_1.Connection {
    NFTBaseApi(name) {
        const selectedResourceClass = base_1.NFTBaseResources[name.toLowerCase()];
        return new selectedResourceClass(this);
    }
    NFTExchangeApi(name) {
        const selectedResourceClass = exchange_1.NFTExchangeResources[name.toLowerCase()];
        return new selectedResourceClass(this);
    }
    guardianApi(name) {
        const selectedResourceClass = guardian_1.GuardianResources[name.toLowerCase()];
        return new selectedResourceClass(this);
    }
}
exports.ProtokolConnection = ProtokolConnection;
//# sourceMappingURL=protokol-connection.js.map